import type { AxiosResponse } from "axios";
import { useAppMutation } from "../../../../../../../http/useAppMutation.ts";
import { trackEvent } from "../../../../../../../tracking/tracking.ts";
import { useWorkspaceUuid } from "../../../../../../hooks/useWorkspaceUuid.ts";
import { useBoardUuid } from "../../../../../hooks/useBoardUuid.ts";
import { useGenerateSettings } from "./useGenerateSettings.ts";

export const useGenerateImageFromPrompt = ({
  onSuccess,
}: {
  onSuccess?: (
    response: AxiosResponse<{
      assets_uuids: string[];
    }>,
  ) => void;
}) => {
  const boardUuid = useBoardUuid();
  const workspaceUuid = useWorkspaceUuid();
  const { settings } = useGenerateSettings(boardUuid);

  const {
    mutate: generateImageFromPromptMutation,
    isLoading: isGenerateImageFromPromptLoading,
  } = useAppMutation<{
    assets_uuids: string[];
  }>({
    path: "boards/generate-image-from-prompt",
    invalidate: [
      `workspaces/${workspaceUuid}/boards`,
      `boards/${boardUuid}/assets`,
    ],
    onSuccess: (response) => {
      onSuccess?.(response);
      trackEvent(
        "content:generate",
        {
          generation_type: "Create",
        },
        true,
      );
    },
  }).mutation;

  return {
    mutation: () => {
      generateImageFromPromptMutation({
        board_uuid: boardUuid,
        prompt: settings.prompt,
        reference_generation_params: settings.selectedModels.generationParams,
        num_generations: settings.num_generations,
        generation_ratio: settings.generation_ratio,
        guidance_scale: settings.guidance_scale,
        photo_enabled: settings.enforce_photo ? settings.photo_enabled : null,
      });
    },
    isLoading: isGenerateImageFromPromptLoading,
  };
};
